import { Button, useTranslation, Theme, FAIcon, IconStyle } from '@nextgen-web-framework/all';
import { parseString } from '../../../utils/helper';
import styles from './SponsorCard.module.scss';
import { SponsorCardProps } from './types/propTypes';

export const SponsorCard = ({
  abo,
  addHandler,
  isSelected = false,
  isDisplay = false,
  isInternationalABO = false,
}: SponsorCardProps) => {
  const t = useTranslation();
  const confirmABO = () => {
    addHandler?.(abo);
  };

  const clearABO = () => {
    addHandler?.(null);
  };

  return (
    <div
      className={`${styles['sponsor-card']} ${isSelected || isDisplay ? styles['selected'] : ''}`}
      data-testid="test-sponsor-card"
    >
      <div className={styles['left-section']}>
        <div className={styles['card-name']}>{parseString(abo?.accountName)}</div>
        {isInternationalABO && (
          <div className={styles['card-field']}>
            {t('profile.sponsorCard.aboType')}:{' '}
            <span className={styles['card-value']}>{t('profile.sponsorCard.international')}</span>
          </div>
        )}
        <div className={styles['card-field']}>
          {t('profile.sponsorCard.aboNumber')}: <span className={styles['card-value']}>{abo?.accountNumber}</span>
        </div>
        <div className={styles['card-field']}>
          {t('profile.sponsorCard.location')}: <span className={styles['card-value']}>{abo?.location}</span>
        </div>
        <div></div>
      </div>

      <div className={styles['right-section']}>
        {!isDisplay && (
          <>
            {isSelected ? (
              <FAIcon
                iconName="xmark-large"
                iconStyle={IconStyle.REGULAR}
                theme={Theme.BLACK}
                className={styles['remove-icon']}
                onClick={clearABO}
                data-testid={'test-sponsor-card-remove-icon'}
              />
            ) : (
              <Button
                title={t('profile.sponsorCard.add')}
                onClick={confirmABO}
                data-testid="test-sponsor-card-button"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
